export const SIMPLE_SEARCH_TAB_ID = 'simpleSearch'
export const ADVANCED_SEARCH_TAB_ID = 'advancedSearch'
export const INPUT_FIELD_PREFIX = 'input-'
export const OUTPUT_FIELD_PREFIX = 'output-'
